export const predefinedRoutes = [
    {
        'name': 'droga_do_szkoly',
        'title': 'droga_do_szkoly_title',
        'description': 'droga_do_szkoly_opis',
        'hash_task': 'dc17a032',
        'hash': '7e26b4d3',
        'img': '/akademia/image/predefinedRoutesImg/droga_do_szkoly.jpg',
        'link_scenarios': 'droga_do_szkoly_scenariusz',
        'early_school_education': 'edukacja_wczesnoszkolna_1',
        'link_buy_education': 'link_edukacja_wczesnoszkolna_1',
        'link_puzzles': 'link_puzzle_podstawowe',
        'buy_puzzles': 'kup_podstawowe',
    },
    {
        'name': 'pyszne_zdrowe_kolorowe',
        'title': 'pyszne_zdrowe_kolorowe_title',
        'description': 'pyszne_zdrowe_kolorowe_opis',
        'hash_task': 'cfa9de57',
        'hash': '8fd297dd',
        'img': '/akademia/image/predefinedRoutesImg/pyszne_zdrowe_kolorowe.jpg',
        'link_buy_scenarios': 'pyszne_zdrowe_kolorowe_scenariusz',
        'early_school_education': 'edukacja_wczesnoszkolna_3',
        'link_buy_education': 'link_edukacja_wczesnoszkolna_3',
        'link_puzzles': 'link_puzzle_podstawowe',
        'buy_puzzles': 'kup_podstawowe',
    },
    {
        'name': 'co_z_chmury_leci',
        'title': 'co_z_chmury_leci_title',
        'description': 'co_z_chmury_leci_opis',
        'hash_task': '85cdc9d5',
        'hash': 'd7b14498',
        'img': '/akademia/image/predefinedRoutesImg/co_z_chmury_leci.jpg',
        'link_buy_scenarios': 'co_z_chmury_leci_scenariusz',
        'early_school_education': 'edukacja_wczesnoszkolna_3',
        'link_buy_education': 'link_edukacja_wczesnoszkolna_3',
        'link_puzzles': 'link_puzzle_podstawowe_i_dodatkowe',
        'buy_puzzles': 'kup_dwa_zestawy',
    },
    {
        'name': 'przygotowania_do_zimy',
        'title': 'przygotowania_do_zimy_title',
        'description': 'przygotowania_do_zimy_opis',
        'hash_task': 'be487c63',
        'hash': '86d3c8db',
        'img': '/akademia/image/predefinedRoutesImg/przygotowania_do_zimy.jpg',
        'link_buy_scenarios': 'przygotowania_do_zimy_scenariusz',
        'early_school_education': 'edukacja_wczesnoszkolna_3',
        'link_buy_education': 'link_edukacja_wczesnoszkolna_3',
        'link_puzzles': 'link_puzzle_podstawowe',
        'buy_puzzles': 'kup_podstawowe',
    },
    {
        'name': 'jak_wyglada_choinka',
        'title': 'jak_wyglada_choinka_title',
        'description': 'jak_wyglada_choinka_opis',
        'hash_task': '543ba1d7',
        'hash': 'cd874564',
        'img': '/akademia/image/predefinedRoutesImg/jak_wyglada_choinka.jpg',
        'link_buy_scenarios': 'jak_wyglada_choinka_scenariusz',
        'early_school_education': 'edukacja_wczesnoszkolna_3',
        'link_buy_education': 'link_edukacja_wczesnoszkolna_3',
        'link_puzzles': 'link_puzzle_podstawowe',
        'buy_puzzles': 'kup_podstawowe',
    },
    {
        'name': 'zakodowana_zima',
        'title': 'zakodowana_zima_title',
        'description': 'zakodowana_zima_opis',
        'hash_task': 'ab3b51c5',
        'hash': '732c9f74',
        'img': '/akademia/image/predefinedRoutesImg/zakodowana_zima.jpg',
        'link_buy_scenarios': 'zakodowana_zima_scenariusz',
        'early_school_education': 'edukacja_wczesnoszkolna_3',
        'link_buy_education': 'link_edukacja_wczesnoszkolna_3',
        'link_puzzles': 'link_puzzle_podstawowe',
        'buy_puzzles': 'kup_podstawowe',
    },
    {
        'name': 'wiosenna_laka',
        'title': 'wiosenna_laka_title',
        'description': 'wiosenna_laka_opis',
        'hash_task': '1d540949',
        'hash': 'f26a9157',
        'img': '/akademia/image/predefinedRoutesImg/wiosenna_laka.jpg',
        'link_buy_scenarios': 'wiosenna_laka_scenariusz',
        'early_school_education': 'edukacja_wczesnoszkolna_3',
        'link_buy_education': 'link_edukacja_wczesnoszkolna_3',
        'link_puzzles': 'link_puzzle_podstawowe_i_dodatkowe',
        'buy_puzzles': 'kup_dwa_zestawy',
    },
    {
        'name': 'kolorowe_weze',
        'title': 'kolorowe_weze_title',
        'description': 'kolorowe_weze_opis',
        'hash_task': 'f97da49d',
        'hash': '41a25d1b',
        'img': '/akademia/image/predefinedRoutesImg/kolorowe_weze.jpg',
        'link_buy_scenarios': 'kolorowe_weze_scenariusz',
        'early_school_education': 'edukacja_wczesnoszkolna_3',
        'link_buy_education': 'link_edukacja_wczesnoszkolna_3',
        'link_puzzles': 'link_puzzle_dodatkowe',
        'buy_puzzles': 'kup_dodatkowe',
    },
    {
        'name': 'poznaje_przedszkole',
        'title': 'poznaje_przedszkole_title',
        'description': 'poznaje_przedszkole_opis',
        'hash_task': 'c9ea0cc2',
        'hash': '79891b16',
        'img': '/akademia/image/predefinedRoutesImg/poznaje_przedszkole.jpg',
        'link_buy_scenarios': 'poznaje_przedszkole_scenariusz',
        'early_school_education': 'edukacja_przedszkolna_2',
        'link_buy_education': 'link_edukacja_przedszkolna_2',
        'link_puzzles': 'link_puzzle_podstawowe',
        'buy_puzzles': 'kup_podstawowe',
    },
    {
        'name': 'poznaje_grzyby',
        'title': 'poznaje_grzyby_title',
        'description': 'poznaje_grzyby_opis',
        'hash_task': 'c7a76513',
        'hash': 'cbfc1a9e',
        'img': '/akademia/image/predefinedRoutesImg/poznaje_grzyby.jpg',
        'link_buy_scenarios': 'poznaje_grzyby_scenariusz',
        'early_school_education': 'edukacja_przedszkolna_2',
        'link_buy_education': 'link_edukacja_przedszkolna_2',
        'link_puzzles': 'link_puzzle_podstawowe',
        'buy_puzzles': 'kup_podstawowe',
    },
    // {
    //     'name': 'jestem_bezpieczny_na_drodze',
    //     'title': 'jestem_bezpieczny_na_drodze_title',
    //     'description': 'jestem_bezpieczny_na_drodze_opis',
    //     'hash': '4a564bb5',
    //     'img': '/akademia/image/predefinedRoutesImg/jestem_bezpieczny_na_drodze.jpg',
    //     'link_buy_scenarios': 'jestem_bezpieczny_na_drodze_scenariusz',
    //     'early_school_education': 'edukacja_przedszkolna_2',
    //     'link_buy_education': 'link_edukacja_przedszkolna_2',
    //     'link_puzzles': 'link_puzzle_podstawowe',
    //     'buy_puzzles': 'kup_podstawowe',
    // },
    {
        'name': 'matematyka_z_puzzlami',
        'title': 'matematyka_z_puzzlami_title',
        'description': 'matematyka_z_puzzlami_opis',
        'hash_task': 'b0aa5ac0',
        'hash': '715d7b3b',
        'img': '/akademia/image/predefinedRoutesImg/matematyka_z_puzzlami.jpg',
        'link_buy_scenarios': 'jestem_bezpieczny_na_drodze_scenariusz',
        'early_school_education': 'edukacja_przedszkolna_2',
        'link_buy_education': 'link_edukacja_przedszkolna_2',
        'link_puzzles': 'link_puzzle_podstawowe',
        'buy_puzzles': 'kup_podstawowe',
    },
    {
        'name': 'pory_roku',
        'title': 'pory_roku_title',
        'description': 'pory_roku_opis',
        'hash_task': '4ea09996',
        'hash': 'd571b884',
        'img': '/akademia/image/predefinedRoutesImg/pory_roku.jpg',
        'link_buy_scenarios': 'pory_roku_scenariusz',
        'early_school_education': 'edukacja_przedszkolna_2',
        'link_buy_education': 'link_edukacja_przedszkolna_2',
        'link_puzzles': 'link_puzzle_podstawowe',
        'buy_puzzles': 'kup_podstawowe',
    },
    // {
    //     'name': 'zakodowany_labirynt',
    //     'title': 'zakodowany_labirynt_title',
    //     'description': 'zakodowany_labirynt_opis',
    //     'hash': '84092261',
    //     'img': '/akademia/image/predefinedRoutesImg/zakodowany_labirynt.jpg',
    //     'link_buy_scenarios': 'zakodowany_labirynt_scenariusz',
    //     'early_school_education': 'edukacja_przedszkolna_2',
    //     'link_buy_education': 'link_edukacja_przedszkolna_2',
    //     'link_puzzles': 'link_puzzle_podstawowe',
    //     'buy_puzzles': 'kup_podstawowe',
    // },
    {
        'name': 'trasy_w_pojazdach_ukryte',
        'title': 'trasy_w_pojazdach_ukryte_title',
        'description': 'trasy_w_pojazdach_ukryte_opis',
        'hash_task': 'b2b7020a',
        'hash': 'edcf4b0e',
        'img': '/akademia/image/predefinedRoutesImg/trasy_w_pojazdach_ukryte.jpg',
        'link_buy_scenarios': 'trasy_w_pojazdach_ukryte_scenariusz',
        'early_school_education': 'edukacja_przedszkolna_2',
        'link_buy_education': 'link_edukacja_przedszkolna_2',
        'link_puzzles': 'link_puzzle_podstawowe',
        'buy_puzzles': 'kup_podstawowe',
    },
    {
        'name': 'rzeka',
        'title': 'rzeka_title',
        'description': 'rzeka_opis',
        'hash_task': 'f9ed6d3d',
        'hash': 'a25f1b26',
        'img': '/akademia/image/predefinedRoutesImg/rzeka.jpg',
        'link_cards': 'rzeka_scenariusz',
        'link_puzzles': 'link_puzzle_dodatkowe',
        'buy_puzzles': 'kup_dodatkowe',
    },
    // {
    //     'name': 'znaki_ostrzegawcze',
    //     'title': 'znaki_ostrzegawcze_title',
    //     'description': 'znaki_ostrzegawcze_opis',
    //     'hash': 'd5cffc84',
    //     'img': '/akademia/image/predefinedRoutesImg/znaki_ostrzegawcze.jpg',
    //     'link_cards': 'znaki_ostrzegawcze_scenariusz',
    //     'link_puzzles': 'link_puzzle_podstawowe',
    //     'buy_puzzles': 'kup_podstawowe',
    // },
    {
        'name': 'kolorowe_sciezki_trasa',
        'description': 'kolorowe_sciezki_trasa_opis',
        'hash_task': 'ae9f00c5',
        'hash': 'd624c79e',
        'img': '/akademia/image/predefinedRoutesImg/kolorowe_sciezki_trasa.jpg',
        'link_puzzles': 'link_puzzle_podstawowe_i_dodatkowe',
        'buy_puzzles': 'kup_dwa_zestawy',
    },
    {
        'name': 'ortografia_latwiejsza_niz_myslisz',
        'title': 'ortografia_latwiejsza_niz_myslisz_title',
        'description': 'ortografia_latwiejsza_niz_myslisz_opis',
        'hash': 'd60faea8',
        'img': '/akademia/image/predefinedRoutesImg/ortografia_latwiejsza_niz_myslisz.jpg',
        'link_buy_scenarios': 'ortografia_latwiejsza_niz_myslisz_scenariusz',
        'early_school_education': 'edukacja_wczesnoszkolna_3',
        'link_buy_education': 'link_edukacja_wczesnoszkolna_3',
        'link_puzzles': 'link_puzzle_podstawowe',
        'buy_puzzles': 'kup_podstawowe',
    },
    {
        'name': 'quiz_z_ozobotem',
        'description': 'quiz_z_ozobotem_opis',
        'hash': '7b4a849c',
        'img': '/akademia/image/predefinedRoutesImg/quiz_z_ozobotem.jpg',
        'link_puzzles': 'link_puzzle_dodatkowe',
        'buy_puzzles': 'kup_dodatkowe',
    },
    // {
    //     'name': 'unikaj_czerwonego',
    //     'description': 'unikaj_czerwonego_opis',
    //     'hash': '0de6b386',
    //     'img': '/akademia/image/predefinedRoutesImg/unikaj_czerwonego.jpg',
    //     'link_puzzles': 'link_puzzle_dodatkowe',
    //     'buy_puzzles': 'kup_dodatkowe',
    // },
];



// WEBPACK FOOTER //
// ./src/predefinedRoutes.js